



































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  AuthType,
  LoginMethod,
  MfaStatusEnum,
} from "@/shared/types";
import { mergeReturnUrl } from "@/shared/loginNavigation";
import _ from "lodash";
import { Validator } from "vee-validate";
import {
  Location,
  RawLocation
} from "vue-router";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import * as routes from "@/employee/route-names";
import { Home } from "@/shared/route-names";
import BiometricAuthLogin from "@/shared/components/BiometricAuthLogin.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { useMfaStore } from "@/shared/store/mfa";
import { useThemeStore } from "@/shared/store/theme";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import Fdic from "@/shared/components/Fdic.vue";
import { useFdicStore } from "../store/fdic";

Component.registerHooks([ "beforeRouteLeave" ]);
@Component({
  components: {
    Input,
    Button,
    LoginWrapper,
    GenericLoadingSpinner,
    BiometricAuthLogin,
    Fdic
  }
})

export default class Login extends Vue {
  $validator: Validator;
  notifierStore = useNotifierStore();
  userStore = useUserStore();
  mfaStore = useMfaStore();
  themeStore = useThemeStore();
  custodianSettingsStore = useCustodianSettingsStore();
  fdicStore = useFdicStore();

  routes = routes;

  @Prop()
  routeToForgotPassword;

  @Prop()
  routeToUpdatePassword: (user: string, password: string) => Location;

  @Prop()
  MfaRouteFunc: (username: string, password: string, mfaStatus: MfaStatusEnum,
                 SetupBiometricAuth: boolean) => RawLocation;

  @Prop()
  routeToBiometricAuthSetup: (user: string, password: string) => Location;

  isSubmitting = false;
  isModeLoading = false;
  showNoAccessMessage = false;
  username = "";
  password = "";
  setupBiometricAuth = false;

  get activationCode () {
    return this.$route.query.code || "";
  }

  get returnUrl (): string {
    return this.$route.query.returnUrl as string || "";
  }

  mounted () {
    const mfaDisableCode = (this.$route.query.mdc as string) || "";
    if (mfaDisableCode) {
      this.mfaStore.disableMfaWithCode({ code: mfaDisableCode }).then(_ => {
        if (_) this.notifierStore.setSuccess("Multi-factor authentication has been disabled.");
      });
      return;
    }

    const partnerId = this.$route.query.partner;
    const parsedPartnerId = _.toSafeInteger(partnerId || 0);

    if (parsedPartnerId !== 0) {
      this.custodianSettingsStore.getCustodianSettingsForPartner(parsedPartnerId);
    }

    this.themeStore.getTheme({ partnerId: parsedPartnerId, employerId: 0, forceUpdate: true });
    this.onActivationCodeChange(this.activationCode);

    this.userStore.setAuthType(AuthType.Cognito);
  }

  @Watch("activationCode")
  onActivationCodeChange (activationToken) {
    if (!activationToken) {
      return;
    }

    const [ id, pw ] = activationToken.split("|");
    if (!id || !pw) {
      return;
    }

    this.userStore.sendIndividualSignupEmailClick(id);
    this.username = id;
    this.password = pw;
    this.isModeLoading = true;
    setTimeout(() => this.submitNoValidate(), 100);
  }

  @Watch("userStore.noAccess")
  onNoAccessValueChange () {
    this.showNoAccessMessage = this.userStore.noAccess;
    if (this.showNoAccessMessage) {
      this.isSubmitting = false;
    }
  }

  @Watch("userStore.loggedIn")
  onLoggedIn (newValue) {
    if (newValue === true) {
      this.mfaStore.sendMfaStatus({ status: this.mfaStore.mfaStatus });
      this.next();
    }
  }

  @Watch("$route.query.partner")
  getCustomizationsForPartnerChange () {
    const partnerId = this.$route.query.partner;
    const parsedPartnerId = _.toSafeInteger(partnerId);

    this.themeStore.getTheme({ partnerId: parsedPartnerId, employerId: 0, forceUpdate: true });
  }

  next () {
    if (this.setupBiometricAuth) {
      this.$router.push(this.routeToBiometricAuthSetup(this.username, this.password));
    } else if (this.$route.query && this.$route.query.returnUrl) {
      this.$router.push(this.$route.query.returnUrl as string);
    } else {
      this.$router.push({ name: Home });
    }
  }

  mfaCheck () {
    if (this.mfaStore.mfaStatus === MfaStatusEnum.Disabled) {
      return;
    }

    this.$router.push(
        this.MfaRouteFunc(this.username, this.password, this.mfaStore.mfaStatus, this.setupBiometricAuth));
  }

  @Watch("userStore.cognitoDR")
  onCognitoDisasterRecoveryDetected (newValue) {
    if (newValue) {
      this.notifierStore.setSuccess("You have received a new password at your email on file.");
      this.password = "";
    }
  }

  submitNoValidate () {
    this.isSubmitting = true;
    this.showNoAccessMessage = false;

    this.userStore.setLoginMethod(LoginMethod.DirectLogin);
    this.userStore.login({
          username: this.username, password: this.password, verificationCode: this.verificationCode, logoutOnStart: true
        })
        .then(_ => {
          this.isSubmitting = false;
          this.mfaCheck();
        })
        .catch(
            err => {
              this.failureCallback(err);
            }
        );
  }

  get verificationCode (): string {
    if (this.returnUrl && this.returnUrl.includes("claim-account")) {
      const code = (new URLSearchParams(this.returnUrl.substr(this.returnUrl.indexOf("?")))).get("c");
      if (code) {
        return code;
      }
      return null;
    }
    return null;
  }

  onSubmit () {
    this.notifierStore.clearAlerts();

    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }
      this.submitNoValidate();
    });
  }

  failureCallback (err) {
    if (err && err.newPasswordRequired) {

      return this.$router.push(this.routeToUpdatePassword(this.username, this.password));
    }
    this.notifierStore.setDanger(err.message);
    this.isSubmitting = false;
    this.setupBiometricAuth = false;
  }

  get submitDisabled () {
    return this.isSubmitting === true || this.$validator.errors.any();
  }

  get forgotPasswordRoute () {
    return mergeReturnUrl(this.$route, this.routeToForgotPassword);
  }

  beforeRouteLeave (to, from, next) {
    if (this.userStore.loggedIn || to.matched.some(r => r.meta.allowAnonymous)) {
      next();
    } else {
      next(false);
    }
  }
}
